import './Switch.scss';

function Switch({ checked, onChange, label, disabled = false, className = '', ...rest }) {
  return (
    <label className={`switch ${disabled ? 'switch--disabled' : ''} ${className}`}>
      <input
        type="checkbox"
        className="switch__input"
        checked={checked}
        onChange={(e) => !disabled && onChange?.(e.target.checked)}
        disabled={disabled}
        {...rest}
      />
      <span className="switch__track">
        <span className="switch__thumb" />
      </span>
      {label && <span className="switch__label">{label}</span>}
    </label>
  );
}

export default Switch;
